import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26deaa52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "mb-2 col-lg-8" }
const _hoisted_3 = ["name", "placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_5 = { class: "col-lg-3 pl-70" }

import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Button from '@/components/button/index.vue'
import { PropType, computed, ref } from 'vue'
import { minLength } from '@vuelidate/validators'
import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { REGEX_EMOJI } from '@/constants/regex'
import useVuelidate from '@vuelidate/core'
import { customMaxLength } from '@/utils'
import { InvitationKeyType } from '@/constants/type'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'


export default /*#__PURE__*/_defineComponent({
  props: {
  invitationKey: {
    type: Object as PropType<InvitationKeyType>,
    default: () => ({
      invited_code: '',
      invited_route: '',
      invited_route_name: '',
      invited_route_name_default: '',
    }),
  },
},
  emits: ['setModalData'],
  setup(__props, { emit }) {

const props = __props




const setModalData = (): void => {
  emit('setModalData', props.invitationKey)
}

const rules = computed(() => {
  return {
    invited_route_name: {
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
  }
})

const ngWordInvitedRouteName = ref<boolean>(false)
const isCheckedNgWord = {
  invited_route_name: false,
}

const checkNgWordInvitedRouteName = debounce(async () => {
  const queryData = { sentence: v$.value.invited_route_name.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordInvitedRouteName.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.invited_route_name = true
  }
}, 200)

const v$ = useVuelidate(rules, props.invitationKey)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 'route_name_key' + __props.invitationKey.invited_route,
        type: "text",
        name: 'route_name' + __props.invitationKey.invited_route,
        placeholder: __props.invitationKey.invited_route_name_default,
        class: _normalizeClass(['form-control', 'mb-10', ngWordInvitedRouteName.value || _unref(v$).invited_route_name.$error ? 'is-invalid' : '']),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).invited_route_name.$model) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNgWordInvitedRouteName) && _unref(checkNgWordInvitedRouteName)(...args)))
      }, null, 42, _hoisted_3)), [
        [
          _vModelText,
          _unref(v$).invited_route_name.$model,
          void 0,
          { trim: true }
        ]
      ]),
      _createVNode(InputErrorMessage, {
        title: __props.invitationKey.invited_route_name_default,
        params: [1, 20],
        validator: _unref(v$).invited_route_name.$errors[0]?.$validator
      }, null, 8, ["title", "validator"]),
      (ngWordInvitedRouteName.value && !_unref(v$).invited_route_name.$error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Button, {
        title: _unref(translate)('alumniInvitationUrl'),
        type: 'secondary',
        size: 'small',
        key: __props.invitationKey.invited_route,
        onClick: setModalData,
        "data-bs-toggle": "modal",
        "data-bs-target": '#registerModal',
        className: 'fw-bold mb-10'
      }, null, 8, ["title"])
    ])
  ]))
}
}

})